<template>
  <div class="brand-list">

    <!-- <van-pull-refresh ref="REFIDList" id="IDList" class="listContainer" v-model="isLoading" @refresh="onRefresh" success-text="刷新成功">
      <van-list v-model="loading"  :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="1"> -->
    <div class="item-box" v-if="couponListUi.length != 0">
      <van-row class="list">
        <div class="item-box-c" v-for="(item,index) in couponListUi" :key="index">

          <coupon :coupinItem="item" :isShowBtnRight="false"></coupon>
          <div class="select" @click="checkedChange(item)">
            <van-checkbox v-model="item.checked" icon-size="18px"></van-checkbox>
          </div>
        </div>

      </van-row>
    </div>
    <div class="coupon-no" v-else>暂无可用优惠券</div>
    <!-- </van-list>
    </van-pull-refresh> -->
    <div class="confirm">
      <van-button @click="clearCoupon" class="confirm-btn" round type="info">不使用优惠券</van-button>
      <van-button @click="setCoupon" class="confirm-btn" round type="info">确定</van-button>

    </div>
  </div>
</template>

<script>
import coupon from "@/components/coupon";

import { couponSelectlist } from "@/api/index";
import { Dialog } from "vant";

export default {
  name: "selectCoupon",
  components: {
    coupon
  },
  data() {
    return {
      couponListUi: [],
      isLoading: true,
      loading: false,
      finished: false,
      data: {
        cartId: 0,
        grouponRulesId: 0
      },
      cartCheckoutData: {},
      checked: false
    };
  },
  mounted() {
    console.log(JSON.parse(this.$route.query.cartCheckoutData));
    this.cartCheckoutData = JSON.parse(this.$route.query.cartCheckoutData);
    this.getcouponList(this.cartCheckoutData);
  },
  methods: {
    getcouponList(data) {
      couponSelectlist(data).then(res => {
        if (res.data.errno == 0) {
          let newOfRes = JSON.parse(JSON.stringify(res.data.data));
          this.couponListUi = newOfRes;
          // this.couponListUi = this.couponListUi.concat(newOfRes.couponListUi);
          // this.couponListUi = newOfRes.data;
          // this.couponListUi.forEach(item => {
          //   item.checked = false;
          // });
          // this.loading = false;
          // 数据全部加载完成
          // if (this.couponListUi.length == newOfRes.count) {
          //   this.finished = true;
          // }
        } else if (res.data.errno == 501) {
          this.$router.push("/login");
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg
          });
        }
      });
    },
    navToDetail(id) {
      this.$router.push({
        path: "/type/detail",
        name: "商品详情",
        query: {
          id: id
        }
      });
    },
    setCoupon() {
      //设置优惠券
      this.$router.go(-1);
    },
    clearCoupon() {
      this.$router.go(-1);
      sessionStorage.setItem("couponId", -1);
    },
    checkedChange(item) {
      this.couponListUi.forEach(element => {
        element.checked = false;
        if (item.id == element.id) {
          item.checked = true;
        }
      });
      this.couponListUi = JSON.parse(JSON.stringify(this.couponListUi));
      sessionStorage.setItem("couponId", item.id);
      // let data = {
      //   cartId: this.cartCheckoutData.cartId,
      //   couponId: item.id,
      //   addressId: this.cartCheckoutData.addressId,
      //   grouponRulesId: this.cartCheckoutData.grouponRulesId
      // };
      // console.log(data);

      // cartCheckout(data).then(res => {
      //   if (res.data.errno == 0) {
      //     this.$router.go(-1);
      //   }
      // });
    }
  }
};
</script>

<style lang="scss" scoped>
.brand-list {
  height: 100%;
  background: #f4f4f4;
  overflow-y: scroll;
  .brand-top {
    position: relative;
    .brand-title {
      position: absolute;
      top: 19%;
      text-decoration: underline;
      width: 100%;
      left: 50%;
      margin-left: -50%;
      color: #fff;
      font-size: 1.8rem;
    }
    img {
      width: 100%;
      height: auto;
    }
  }
  .brand-name {
    height: 3rem;
    line-height: 3rem;
  }
}
.item-box {
  width: 100%;
  margin-top: 1rem;
  padding: 0 1.6rem 6rem;
  box-sizing: border-box;

  .list {
    width: 100%;
    margin: 0 auto;
    .item-box-c {
      position: relative;
      .select {
        position: absolute;
        right: 3rem;
        height: 100%;
        top: 45%;
      }
    }
  }
}
.coupon-no {
  font-size: 1.7rem;
  margin: 7rem auto;
}
.confirm {
  background: #fff;
  position: fixed;
  bottom: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  height: 6rem;
  width: 100%;
  .confirm-btn {
    width: 36%;
  }
}
/deep/ .van-button--info {
  background: #d6be93;
  border: 0;
}
/deep/ .van-checkbox__icon--checked .van-icon {
  background-color: #d6be93;
  border-color: #d6be93;
}
</style>



// WEBPACK FOOTER //
// src/view/shopCar/selectCoupon.vue